module.exports = __webpack_public_path__ + "img/ep4-1.e7364322.png";